import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { colors } from "../../Utils/color"
import MoviesSlider from "../../Components/MoviesSlider"
import { useNavigate } from "react-router-dom"
import { LoaderDiv } from "../../Utils/style"
import AdsterraBanner from "../../Components/AdsterraBanner"
import ExoClickBanner728x90 from "../../Components/ExoClickBanner728x90"
import ExoClickBannerMobile from "../../Components/ExoClickBannerMobile"
import HilltopAdsBanner from "../../Components/HilltopAdsBanner"
import AdsterraSocialBar from "../../Components/AdsterraSocialBar"
import AdsterraNativeBanner from "../../Components/AdsterraNativeBanner"

const HomeDiv = styled.div`
    padding: 120px 0;
`
const HomeH2 = styled.h2`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    width: fit-content;
    font-size: 1.4rem;
    margin: 10px 15px;
    //margin: 20px 15px;
    @media screen and (min-width: 1024px) {
        margin: 20px 0 20px 100px;
    }
`
const HomeTitleLine = styled.p`
    width: 130%;
    height: 6px;
    background-color: ${colors.primary};
    border-radius: 4px;
    margin: 0;
    margin-left: 35px;
    margin-top: 8px;
    @media screen and (min-width: 1024px) {
        //margin: 0;
        //margin-top: 8px;
    }
`
const LatestMoviesDiv = styled.div`
    width: 100%;
    position: relative;

    > .HomeAfficherDiv {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .afficherSuite {
            color: ${colors.textColor};
            font-size: 1.1em;
            font-weight: 500;
            text-decoration: underline;
            margin: 20px;
            align-self: flex-end;
            cursor: pointer;
            &:hover {
                color: ${colors.primary};
                font-size: 1.15em;
            }
            @media screen and (min-width: 1024px) {
                font-size: 1.1em;
                margin: 0 20px 20px 0;
            }

            > .fa-solid {
                font-size: 0.85em;
                margin-left: 7px;
                transform: translateY(10%);
            }
        }
    }

    > .fa-solid {
        position: absolute;
        top: 43%;
        font-size: 2.8rem;
        display: none;
        cursor: pointer;
        &:hover {
            font-size: 3rem;
        }
        @media screen and (min-width: 1024px) {
            display: block;
        }
    }
    > .fa-chevron-left {
        left: 40px;
    }
    > .fa-chevron-right {
        right: 40px;
    }
`
export const AddBannerDiv = styled.div`
    max-width: 900px;
    height: fit-content;
    margin: 0 auto;
    > p {
        margin: 0;
        opacity: 0.8;
    }
`
export const StakeBannersDiv = styled.div`
    width: fit-content;
    height: fit-content;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
    > p {
        margin: 0;
        opacity: 0.8;
    }

    > .stakeLink {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        cursor: pointer;
    }
`
export const HilltopAdsScript = styled.script`
    margin-bottom: 300px;
    background-color: aliceblue;
    z-index: 1000;
`

function Home() {
    const [movies, setMovies] = useState([])
    const [series, setSeries] = useState([])
    const [trendyMovies, seTrendyMovies] = useState([])
    const [trendySeries, seTrendySeries] = useState([])
    const moviesRef = useRef(null)
    const seriesRef = useRef(null)
    const trendyMoviesRef = useRef(null)
    const TrendySeriesRef = useRef(null)

    const [loading, setLoading] = useState(true)

    const fetchFSTVDatas = async () => {
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(`${API_BASE}/api/index`)
            const json = await response.json()

            setMovies(json.films)
            setSeries(json.series)
            seTrendyMovies(json.trendyFilms)
            seTrendySeries(json.trendySeries)
        } catch (error) {
            console.error("Fetch error: ", error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        document.title =
            "Streamflix-fr | Des films et series gratuits en streaming"
        fetchFSTVDatas()
    }, [])

    const scrollHandleClick = (element, speed, distance, step) => {
        let scrollAmount = 0
        const sliderTimer = setInterval(() => {
            element.scrollLeft += step
            scrollAmount += Math.abs(step)

            if (scrollAmount >= distance) {
                clearInterval(sliderTimer)
            }
        }, speed)
    }

    const navigate = useNavigate()
    const allFstvHandleClick = (event) => {
        const btnID = event.target.id
        navigate("/" + btnID + "?page=1")
    }

    const isMobile = window.innerWidth < 768

    return (
        <HomeDiv>
            {loading && <LoaderDiv />}

            {/*<AddBannerDiv>
                {isMobile ? <ExoClickBannerMobile /> : <ExoClickBanner728x90 />}
            </AddBannerDiv>*/}

            {!loading && trendyMovies && (
                <LatestMoviesDiv>
                    <div className="HomeAfficherDiv">
                        <HomeH2>
                            Films Tendance <HomeTitleLine />
                        </HomeH2>
                    </div>

                    <i
                        className="fa-solid fa-chevron-left"
                        onClick={() => {
                            scrollHandleClick(
                                trendyMoviesRef.current,
                                25,
                                window.innerWidth / 2,
                                -30,
                            )
                        }}
                    ></i>
                    <i
                        className="fa-solid fa-chevron-right"
                        onClick={() => {
                            scrollHandleClick(
                                trendyMoviesRef.current,
                                25,
                                window.innerWidth / 2,
                                30,
                            )
                        }}
                    ></i>

                    <MoviesSlider
                        movies={trendyMovies}
                        moviesRef={trendyMoviesRef}
                        type={"film"}
                    />
                </LatestMoviesDiv>
            )}

            {!loading && movies && (
                <LatestMoviesDiv>
                    <div className="HomeAfficherDiv">
                        <HomeH2>
                            Derniers Films <HomeTitleLine />
                        </HomeH2>
                        <p
                            id="films"
                            className="afficherSuite"
                            onClick={allFstvHandleClick}
                        >
                            Tout explorer
                            <i class="fa-solid fa-chevron-right"></i>
                        </p>
                    </div>

                    <i
                        className="fa-solid fa-chevron-left"
                        onClick={() => {
                            scrollHandleClick(
                                moviesRef.current,
                                25,
                                window.innerWidth / 2,
                                -30,
                            )
                        }}
                    ></i>
                    <i
                        className="fa-solid fa-chevron-right"
                        onClick={() => {
                            scrollHandleClick(
                                moviesRef.current,
                                25,
                                window.innerWidth / 2,
                                30,
                            )
                        }}
                    ></i>

                    <MoviesSlider
                        movies={movies}
                        moviesRef={moviesRef}
                        type={"film"}
                    />
                </LatestMoviesDiv>
            )}

            {/*<AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>*/}

            {!loading && trendySeries && (
                <LatestMoviesDiv>
                    <div className="HomeAfficherDiv">
                        <HomeH2>
                            Series Tendance <HomeTitleLine />
                        </HomeH2>
                    </div>

                    <i
                        className="fa-solid fa-chevron-left"
                        onClick={() => {
                            scrollHandleClick(
                                TrendySeriesRef.current,
                                25,
                                window.innerWidth / 2,
                                -30,
                            )
                        }}
                    ></i>
                    <i
                        className="fa-solid fa-chevron-right"
                        onClick={() => {
                            scrollHandleClick(
                                TrendySeriesRef.current,
                                25,
                                window.innerWidth / 2,
                                30,
                            )
                        }}
                    ></i>

                    <MoviesSlider
                        movies={trendySeries}
                        moviesRef={TrendySeriesRef}
                        type={"serie"}
                    />
                </LatestMoviesDiv>
            )}

            {!loading && series && (
                <LatestMoviesDiv>
                    <div className="HomeAfficherDiv">
                        <HomeH2>
                            Derniéres Séries <HomeTitleLine />
                        </HomeH2>
                        <p
                            id="series"
                            className="afficherSuite"
                            onClick={allFstvHandleClick}
                        >
                            Tout explorer
                            <i class="fa-solid fa-chevron-right"></i>
                        </p>
                    </div>

                    <i
                        class="fa-solid fa-chevron-left"
                        onClick={() => {
                            scrollHandleClick(
                                seriesRef.current,
                                25,
                                window.innerWidth / 2,
                                -30,
                            )
                        }}
                    ></i>
                    <i
                        class="fa-solid fa-chevron-right"
                        onClick={() => {
                            scrollHandleClick(
                                seriesRef.current,
                                25,
                                window.innerWidth / 2,
                                30,
                            )
                        }}
                    ></i>

                    <MoviesSlider
                        movies={series}
                        moviesRef={seriesRef}
                        type={"serie"}
                    />
                </LatestMoviesDiv>
            )}

            <AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="0ce49bfc0a6847270e97cef8117bdaff"
                        width={468}
                        height={60}
                    />
                ) : (
                    <AdsterraNativeBanner />
                )}
            </AddBannerDiv>
        </HomeDiv>
    )
}

export default Home
